module.exports = __webpack_public_path__ + "img/logo-mobile.4c6c0942.png";